// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-scm-commit {
  overflow: hidden;
  font-size: var(--theia-ui-font-size1);
  max-height: calc(100% - var(--theia-border-width));
  position: relative;
  padding: 5px 5px 0px 19px;
}

.theia-scm {
  box-sizing: border-box;
  height: 100%;
}

.groups-outer-container:focus {
  outline: 0;
  box-shadow: none;
  border: none;
}

.theia-scm .noWrapInfo {
  width: 100%;
  align-items: center;
}

.theia-scm:focus,
.theia-scm :focus {
  outline: 0;
  box-shadow: none;
  border: none;
}

.theia-scm .space-between {
  justify-content: space-between;
}

.theia-scm .changesHeader {
  font-weight: bold;
}

.theia-scm .theia-scm-amend {
  margin: 5px 0;
}

.theia-scm #messageInputContainer {
  position: relative;
}

.theia-scm #repositoryListContainer {
  display: flex;
  margin-bottom: 5px;
  flex: 1;
}

.theia-scm .groups-outer-container {
  overflow-y: auto;
  width: 100%;
  flex-grow: 1;
}

.theia-scm .warn {
  background-color: var(--theia-inputValidation-warningBackground) !important;
}

.theia-scm-main-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.theia-scm-input-message-container {
  display: flex;
  flex-direction: column;
  margin: 0px 0px 7px 0px;
  max-height: 400px;
}

.theia-scm-input-message-container textarea {
  line-height: var(--theia-content-line-height);
  resize: none;
  box-sizing: border-box;
  min-height: 32px;
  padding: 4px;
  border: none;
}

.theia-scm-input-message-container textarea:placeholder-shown {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theia-scm-input-message-container textarea:focus {
  outline: var(--theia-border-width) solid var(--theia-focusBorder);
}

.theia-scm-input-message {
  width: 100%;
}

.theia-scm-input-message-idle:not(:focus) {
  border-color: var(--theia-input-border);
}

.theia-scm-input-message-info {
  border-color: var(--theia-inputValidation-infoBorder) !important;
}

.theia-scm-input-message-success {
  border-color: var(--theia-successBackground) !important;
}

.theia-scm-input-message-warning {
  border-color: var(--theia-inputValidation-warningBorder) !important;
}

.theia-scm-input-message-error {
  border-color: var(--theia-inputValidation-errorBorder) !important;
}

.theia-scm-message,
.theia-scm-input-validation-message {
  padding: 4px 4px 4px 4px;
}

.theia-scm-validation-message-info {
  background-color: var(--theia-inputValidation-infoBackground) !important;
  color: var(--theia-inputValidation-infoForeground);
  border: var(--theia-border-width) solid
    var(--theia-inputValidation-infoBorder);
  border-top: none; /* remove top border since the input declares it already */
}

.theia-scm-validation-message-success {
  background-color: var(--theia-successBackground) !important;
  color: var(--theia-inputValidation-warningBackground);
}

.theia-scm-message-warning,
.theia-scm-validation-message-warning {
  background-color: var(--theia-inputValidation-warningBackground) !important;
  color: var(--theia-inputValidation-warningForeground);
  border: var(--theia-border-width) solid
    var(--theia-inputValidation-warningBorder);
  border-top: none; /* remove top border since the input declares it already */
}

.theia-scm-validation-message-error {
  background-color: var(--theia-inputValidation-errorBackground) !important;
  color: var(--theia-inputValidation-errorForeground);
  border: var(--theia-border-width) solid
    var(--theia-inputValidation-errorBorder);
  border-top: none; /* remove top border since the input declares it already */
}

.no-select:focus {
  outline: none;
}

.theia-scm .scmItem {
  font-size: var(--theia-ui-font-size1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--theia-content-line-height);
  line-height: var(--theia-content-line-height);
  padding: 0px calc(var(--theia-ui-padding) / 2);
}

.theia-scm .scmItem:hover {
  cursor: pointer;
}

.theia-scm:focus-within .scmItem:focus {
  background: var(--theia-list-focusBackground);
  color: var(--theia-list-focusForeground);
}

.theia-scm:not(:focus-within) .scmItem:not(:focus) {
  background: var(--theia-list-inactiveFocusBackground);
}

.theia-scm:focus-within .scmItem.theia-mod-selected {
  background: var(--theia-list-activeSelectionBackground);
  color: var(--theia-list-activeSelectionForeground);
}

.theia-scm:not(:focus-within) .scmItem.theia-mod-selected {
  background: var(--theia-list-inactiveSelectionBackground);
  color: var(--theia-list-inactiveSelectionForeground);
}

.theia-scm .scmItem .path {
  font-size: var(--theia-ui-font-size0);
  margin-left: var(--theia-ui-padding);
  opacity: 0.7;
}

.theia-scm .scmItem .status {
  width: 16px;
  text-align: center;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: var(--theia-ui-font-size0);
}

.theia-scm .decoration-icon {
    margin: 2px 0px;
}

.scm-change-count {
  float: right;
}

.scm-theia-header {
  display: flex;
  align-items: center;
}

.scm-theia-header:hover {
  cursor: pointer;
}

.theia-scm-inline-actions-container {
  display: flex;
  justify-content: flex-end;
  margin-left: 3px;
  min-height: 16px;
}

.theia-scm-inline-actions {
  display: flex;
  margin: 0 3px;
}

.theia-scm-inline-actions a {
  color: var(--theia-icon-foreground);
}

.theia-scm-inline-action {
  font-size: var(--theia-ui-font-size1);
  margin: 0 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.theia-scm-inline-action .open-file {
  height: var(--theia-icon-size);
  width: 12px;
  background: var(--theia-icon-open-file) no-repeat center center;
}

.theia-scm-panel {
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/scm/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kDAAkD;EAClD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,wEAAwE;EACxE,kDAAkD;EAClD;2CACyC;EACzC,gBAAgB,EAAE,0DAA0D;AAC9E;;AAEA;EACE,2DAA2D;EAC3D,qDAAqD;AACvD;;AAEA;;EAEE,2EAA2E;EAC3E,qDAAqD;EACrD;8CAC4C;EAC5C,gBAAgB,EAAE,0DAA0D;AAC9E;;AAEA;EACE,yEAAyE;EACzE,mDAAmD;EACnD;4CAC0C;EAC1C,gBAAgB,EAAE,0DAA0D;AAC9E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uDAAuD;EACvD,kDAAkD;AACpD;;AAEA;EACE,yDAAyD;EACzD,oDAAoD;AACtD;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,+DAA+D;AACjE;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-scm-commit {\n  overflow: hidden;\n  font-size: var(--theia-ui-font-size1);\n  max-height: calc(100% - var(--theia-border-width));\n  position: relative;\n  padding: 5px 5px 0px 19px;\n}\n\n.theia-scm {\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.groups-outer-container:focus {\n  outline: 0;\n  box-shadow: none;\n  border: none;\n}\n\n.theia-scm .noWrapInfo {\n  width: 100%;\n  align-items: center;\n}\n\n.theia-scm:focus,\n.theia-scm :focus {\n  outline: 0;\n  box-shadow: none;\n  border: none;\n}\n\n.theia-scm .space-between {\n  justify-content: space-between;\n}\n\n.theia-scm .changesHeader {\n  font-weight: bold;\n}\n\n.theia-scm .theia-scm-amend {\n  margin: 5px 0;\n}\n\n.theia-scm #messageInputContainer {\n  position: relative;\n}\n\n.theia-scm #repositoryListContainer {\n  display: flex;\n  margin-bottom: 5px;\n  flex: 1;\n}\n\n.theia-scm .groups-outer-container {\n  overflow-y: auto;\n  width: 100%;\n  flex-grow: 1;\n}\n\n.theia-scm .warn {\n  background-color: var(--theia-inputValidation-warningBackground) !important;\n}\n\n.theia-scm-main-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.theia-scm-input-message-container {\n  display: flex;\n  flex-direction: column;\n  margin: 0px 0px 7px 0px;\n  max-height: 400px;\n}\n\n.theia-scm-input-message-container textarea {\n  line-height: var(--theia-content-line-height);\n  resize: none;\n  box-sizing: border-box;\n  min-height: 32px;\n  padding: 4px;\n  border: none;\n}\n\n.theia-scm-input-message-container textarea:placeholder-shown {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theia-scm-input-message-container textarea:focus {\n  outline: var(--theia-border-width) solid var(--theia-focusBorder);\n}\n\n.theia-scm-input-message {\n  width: 100%;\n}\n\n.theia-scm-input-message-idle:not(:focus) {\n  border-color: var(--theia-input-border);\n}\n\n.theia-scm-input-message-info {\n  border-color: var(--theia-inputValidation-infoBorder) !important;\n}\n\n.theia-scm-input-message-success {\n  border-color: var(--theia-successBackground) !important;\n}\n\n.theia-scm-input-message-warning {\n  border-color: var(--theia-inputValidation-warningBorder) !important;\n}\n\n.theia-scm-input-message-error {\n  border-color: var(--theia-inputValidation-errorBorder) !important;\n}\n\n.theia-scm-message,\n.theia-scm-input-validation-message {\n  padding: 4px 4px 4px 4px;\n}\n\n.theia-scm-validation-message-info {\n  background-color: var(--theia-inputValidation-infoBackground) !important;\n  color: var(--theia-inputValidation-infoForeground);\n  border: var(--theia-border-width) solid\n    var(--theia-inputValidation-infoBorder);\n  border-top: none; /* remove top border since the input declares it already */\n}\n\n.theia-scm-validation-message-success {\n  background-color: var(--theia-successBackground) !important;\n  color: var(--theia-inputValidation-warningBackground);\n}\n\n.theia-scm-message-warning,\n.theia-scm-validation-message-warning {\n  background-color: var(--theia-inputValidation-warningBackground) !important;\n  color: var(--theia-inputValidation-warningForeground);\n  border: var(--theia-border-width) solid\n    var(--theia-inputValidation-warningBorder);\n  border-top: none; /* remove top border since the input declares it already */\n}\n\n.theia-scm-validation-message-error {\n  background-color: var(--theia-inputValidation-errorBackground) !important;\n  color: var(--theia-inputValidation-errorForeground);\n  border: var(--theia-border-width) solid\n    var(--theia-inputValidation-errorBorder);\n  border-top: none; /* remove top border since the input declares it already */\n}\n\n.no-select:focus {\n  outline: none;\n}\n\n.theia-scm .scmItem {\n  font-size: var(--theia-ui-font-size1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: var(--theia-content-line-height);\n  line-height: var(--theia-content-line-height);\n  padding: 0px calc(var(--theia-ui-padding) / 2);\n}\n\n.theia-scm .scmItem:hover {\n  cursor: pointer;\n}\n\n.theia-scm:focus-within .scmItem:focus {\n  background: var(--theia-list-focusBackground);\n  color: var(--theia-list-focusForeground);\n}\n\n.theia-scm:not(:focus-within) .scmItem:not(:focus) {\n  background: var(--theia-list-inactiveFocusBackground);\n}\n\n.theia-scm:focus-within .scmItem.theia-mod-selected {\n  background: var(--theia-list-activeSelectionBackground);\n  color: var(--theia-list-activeSelectionForeground);\n}\n\n.theia-scm:not(:focus-within) .scmItem.theia-mod-selected {\n  background: var(--theia-list-inactiveSelectionBackground);\n  color: var(--theia-list-inactiveSelectionForeground);\n}\n\n.theia-scm .scmItem .path {\n  font-size: var(--theia-ui-font-size0);\n  margin-left: var(--theia-ui-padding);\n  opacity: 0.7;\n}\n\n.theia-scm .scmItem .status {\n  width: 16px;\n  text-align: center;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-size: var(--theia-ui-font-size0);\n}\n\n.theia-scm .decoration-icon {\n    margin: 2px 0px;\n}\n\n.scm-change-count {\n  float: right;\n}\n\n.scm-theia-header {\n  display: flex;\n  align-items: center;\n}\n\n.scm-theia-header:hover {\n  cursor: pointer;\n}\n\n.theia-scm-inline-actions-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-left: 3px;\n  min-height: 16px;\n}\n\n.theia-scm-inline-actions {\n  display: flex;\n  margin: 0 3px;\n}\n\n.theia-scm-inline-actions a {\n  color: var(--theia-icon-foreground);\n}\n\n.theia-scm-inline-action {\n  font-size: var(--theia-ui-font-size1);\n  margin: 0 2px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.theia-scm-inline-action .open-file {\n  height: var(--theia-icon-size);\n  width: 12px;\n  background: var(--theia-icon-open-file) no-repeat center center;\n}\n\n.theia-scm-panel {\n  overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
